define('SageDotCom/DataLayer/Events/skinnyBanner',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function SkinnyBannerEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'banner_display'; // overwrite name
    }

    SkinnyBannerEvent.prototype = Object.create(EventBase.prototype);

    SkinnyBannerEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope) {
        var eventData = {
            "event": this.getName() //event name
        }
        if (scope) {
            var link = $(scope).find("a");
            eventData = $.extend(eventData, {
                "message": link.length > 0 ? link[0].innerText : ""
            });
        }
        return eventData;
    }

    return new SkinnyBannerEvent();
});
